import ProgramEmpty from "@images/empty/program_empty.svg"
import { word } from "@modules/core/utils/i18n"
import { Path } from "@modules/navigation/routes"
import { useMySpaceNavigate } from "@modules/navigation/useMySpaceNavigate"
import { ProgramBundleListView } from "@modules/programBundle/components/programBundleListView"
import { useProgramBundles, useProgramBundlesSubscribed } from "@modules/programBundle/hooks/useProgramBundle"
import { useProgramBundleSidebar } from "@modules/programBundle/hooks/useProgramBundleSidebar"
import { EmptyView } from "@modules/ui/components/emptyView"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { PlusIcon } from "lucide-react"
import { useTheme } from "styled-components"

type ProgramBundleListLayoutProps = {} & React.HTMLAttributes<HTMLDivElement>

export const ProgramBundleListLayout: React.FC<ProgramBundleListLayoutProps> = ({ ...props }) => {
  const theme = useTheme()
  const { data: programBundles, isLoading } = useProgramBundles(null)
  const { data: programBundlesSubscribed, isLoading: isLoadingSubscribed } = useProgramBundlesSubscribed()
  const classNameDefault = props.className ?? "flex flex-column mb-8"
  const { navigateToProgramBundleForm } = useProgramBundleSidebar()
  const mySpaceNavigate = useMySpaceNavigate()

  const buttonCreateBundle = (text: string) => (
    <HUButton
      type="Left_Icon"
      colorType="Primary"
      size="L"
      text={text}
      icon={{ iconView: <PlusIcon color={theme.mainBlack} width={15} height={15} /> }}
      className="px-4 py-2"
      onClick={() => navigateToProgramBundleForm({ args: { replaceAllComponents: true } })}
    />
  )

  const buttonSubscribedBundle = (text: string) => (
    <HUButton
      type="Left_Icon"
      colorType="Primary"
      size="L"
      text={text}
      icon={{ iconView: <PlusIcon color={theme.mainBlack} width={15} height={15} /> }}
      className="px-4 py-2  "
      onClick={() => mySpaceNavigate(Path.MySpace.Explore)}
    />
  )

  return (
    <div className={classNameDefault}>
      <HUText className="mb-4" fontStyle="BM" color={theme.neutralColor700}>
        {word("programBundle.header.title")}
      </HUText>

      <ProgramBundleListView
        programBundles={programBundles}
        isLoading={isLoading}
        titleObject={{
          titleText: word("global.created"),
          titleColor: theme.neutralColor900,
          titleBgColor: "bg-neutralColor-100",
        }}
        emptyView={
          <EmptyView
            image={{ src: ProgramEmpty }}
            title={word("programBundle.emptyView.title")}
            description={word("programBundle.emptyView.subTitleCreate")}
            imagePosition="after"
          >
            {buttonCreateBundle(word("programBundle.button.createNew"))}
          </EmptyView>
        }
        button={buttonCreateBundle(word("global.createNew"))}
      />
      <ProgramBundleListView
        programBundles={programBundlesSubscribed}
        isLoading={isLoadingSubscribed}
        titleObject={{
          titleText: word("global.subscribed"),
          titleColor: theme.mainWhite,
          titleBgColor: "bg-forestGreen-500",
        }}
        emptyView={
          <EmptyView
            image={{ src: ProgramEmpty }}
            title={word("programBundle.emptyView.title")}
            description={word("programBundle.emptyView.subTitleFind")}
            imagePosition="after"
          >
            {buttonSubscribedBundle(word("programBundle.button.findNew"))}
          </EmptyView>
        }
        button={buttonSubscribedBundle(word("global.findNew"))}
      />
    </div>
  )
}
